import React from "react";

import CuoButton from "@/app/admin/_common/CuoButton";
import { buttonVariants } from "@/app/admin/_common/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/admin/_common/ui/tooltip";
import { cn } from "@/app/_utils/cn";

type Props = {
  tooltip: string;
  icon: React.ReactNode;
  onClick?: () => void;
  href?: string;
  download?: string;
  active?: boolean;
};

const baseClassName =
  "size-[30px] flex-none p-0 text-muted-foreground hover:text-foreground";

// Square 30px ghost button — the one shape every email-builder toolbar control uses.
export default function ToolbarIconButton({
  tooltip,
  icon,
  onClick,
  href,
  download,
  active,
}: Props) {
  // A download needs a real anchor; CuoButton wraps children in a span, so `asChild` can't
  // reach through to one. Borrow the variant classes instead of nesting a button in a link.
  const control = href ? (
    <a
      href={href}
      download={download}
      aria-label={tooltip}
      className={cn(
        buttonVariants({ variant: "ghost" }),
        "rounded-md font-normal",
        baseClassName
      )}
    >
      {icon}
    </a>
  ) : (
    <CuoButton
      variant="ghost"
      aria-label={tooltip}
      onClick={onClick}
      className={cn(baseClassName, active && "bg-muted text-foreground")}
    >
      {icon}
    </CuoButton>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>{control}</TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
